import { createSelector } from 'reselect';
import { makeSelectCustomOriginFromInstitutionPath } from '../../Institutions/helpers';

export const makeSelectOriginForCoursePath = (coursePath) => {
  const firstSegment = coursePath.toLowerCase().split('/')[0];
  const institutionPrefix = firstSegment === 'courses' ? null : firstSegment;
  return makeSelectCustomOriginFromInstitutionPath(institutionPrefix);
};

export const makeSelectCoursePathUsesCustomDomain = (coursePath) =>
  createSelector(
    [makeSelectOriginForCoursePath(coursePath)],
    (origin) => !!origin
  );

export const makeSelectCoursePathUsesMainDomain = (coursePath) =>
  createSelector(
    [makeSelectOriginForCoursePath(coursePath)],
    (origin) => !origin
  );
